export enum TranslationModuleEnum {
  BAU = 1,

  changeRequests = 2,
  closureRequests = 3,
  dashboard = 4,
  eppmRequests = 5,
  initiationForm = 6,
  Projects = 7,

  requests = 8,
  agentQueue = 9,
  entityDesigner = 10,
  EServices = 11,
  followUp = 12,
  manageForms = 13,
  manageServices = 14,
  Meetings = 15,
  serviceCatalog = 16,
  servicesDashboard = 17,

  Planning = 18,
  overallStrategyPerformance = 19,
  performanceDashboard = 20,
  performanceReports = 21,
  Performance_Shared = 22,
  Performance_ChangeRequest = 23,
  Performance_Planning = 24,
  scoreSubmission = 404,

  jobs = 25,
  volunteer = 3030,

  mediaCenter = 4040,

  committee = 26,
  configuration = 27,
  delegations = 28,
  groups = 29,
  lookups = 30,
  Admin_Process = 31,
  roles = 32,
  users = 33,

  designSystem = 34,
  oops = 35,
  shared = 36,
  manageWorkflow = 37,
  auth = 38,

  Appraisal = 39,
  Committee_Management = 40,
  Event_Registration = 42,
  Events = 43,
  Innovation = 44,

  ManageScorecards = 46,
  Partnership = 51,
  membership = 52,
  booking = 53,
  competition = 54,
  settings = 55,
  donation = 56,
  loyalty = 57,
  
  contentManagement = 58,
}
